import React from 'react';
import moment from 'moment';

import Avatar from '../../common/ui/Avatar';
import { monthDayYearWithSlashFormat } from '../../../constants/date';
import { getSavedAuthToken } from '../../../api/httpClient';
import { serializeToQueryString } from '../../../helpers/general';
import { links } from '../../../constants/general';

export default function WorkerJobSummary ({ worker }) {

  const _renderJobs = () => {

    if (worker.jobs && worker.jobs.length) {
      return worker.jobs.map((job, i) => (
        <div
          className="job-card-worker align-items-center d-flex text-left"
          key={`${i}-${job.id}`}
        >
          <Avatar photo_image_url={job.icon_url}/>

          <div className="d-flex align-items-center w-100 justify-content-between">
            <div>
              <strong>{job.skill_label}</strong>
              <div>{job.location_name || job.address}</div>
            </div>

            <strong>
              {moment(job.start_date).format(monthDayYearWithSlashFormat)}
            </strong>
          </div>
        </div>
      ));
    }

    return (
      <div
        className="text-muted text-left"
        children="Worker has no completed jobs yet."
      />
    );
  };

  return (

    <section className="personal-info">
      {
        (worker.jobs && worker.jobs.length)
          ? <div>
            <div className="section-header-wrapper">
              <h4>Job Summary</h4>
            </div>

            <div className="section-row flex-wrap">
              <span className="section-row-label">Worked:</span>
              <p className="text-primary">{worker.total_jobs_worked || ''}</p>
            </div>

            <div className="section-row flex-wrap">
              <span className="section-row-label">Dropped:</span>
              <p className="text-delete">{worker.dropped_jobs || ''}</p>
            </div>

            <div className="section-header-wrapper text-md text-left mb-2 mt-4">
              Completed jobs:
            </div>
          </div> : <div></div>
      }
      {_renderJobs()}

    </section>

  );
}



// WEBPACK FOOTER //
// ./src/components/app/workerDetails/WorkerJobSummary.js